import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { CalculoFormulaSimularRequest } from '../../requests/formula/calculo-formula-simular.request';
import { CalculoFormulaSimularResponse } from '../../responses/formula/calculo-formula-simular.response';

@Injectable({ providedIn: 'root' })
export class MotorCalculoService extends CommonService {
  private readonly apiUrl = `${environment.urlApiSuprimentos}MotorCalculo`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  /** Simula as fórmulas de um contexto de Suprimentos com o estado em edição na tela. */
  public simular(request: CalculoFormulaSimularRequest): Observable<CalculoFormulaSimularResponse> {
    return this.httpClient.post<CalculoFormulaSimularResponse>(
      `${this.apiUrl}/simular`,
      request,
      this.addHeaderToken()
    ).pipe(catchError(this.handleError));
  }
}
